import { render, staticRenderFns } from "./BankPay.vue?vue&type=template&id=0eddba68&scoped=true&"
import script from "./BankPay.vue?vue&type=script&setup=true&lang=js&"
export * from "./BankPay.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BankPay.vue?vue&type=style&index=0&id=0eddba68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eddba68",
  null
  
)

export default component.exports